export default {
  name: 'vx-rich-text',
  components: {},
  props: {
    richTextMarkup: {
      type: String,
      required: true,
    },
  },
  data() {
    return {};
  },
  computed: {},
  mounted() {},
  methods: {},
};



// WEBPACK FOOTER //
// ./src/components/common/vx-rich-text/vx-rich-text.js